import { __awaiter, __generator } from "tslib";
import { COLORS } from '../constants';
export var HOOK = "data-shape-id";
export var radiansToDegrees = function (radians) {
    if (radians === void 0) { radians = 0; }
    var degrees = radians * (180 / Math.PI);
    return degrees > 180 ? degrees - 360 : degrees;
};
export var degreesToRadians = function (degrees) {
    if (degrees === void 0) { degrees = 0; }
    return ((degrees % 360) * Math.PI) / 180;
};
export var reverseDegrees = function (degrees) { return 360 - degrees; };
export var getElementHookValue = function (id, idPostfix) {
    if (idPostfix === void 0) { idPostfix = ''; }
    var postfix = idPostfix ? "-".concat(idPostfix) : '';
    return "".concat(id).concat(postfix);
};
export var getElementQuery = function (id, idPostfix) {
    var attributeValue = getElementHookValue(id, idPostfix);
    return "[".concat(HOOK, "=\"").concat(attributeValue, "\"]");
};
export var round = function (value, precision) {
    if (precision === void 0) { precision = 0.01; }
    return Math.round(value / precision) * precision;
};
export var floor = function (value, precision) {
    if (precision === void 0) { precision = 0.01; }
    return Math.floor(value / precision) * precision;
};
export var ceil = function (value, precision) {
    if (precision === void 0) { precision = 0.01; }
    return Math.ceil(value / precision) * precision;
};
export var getElement = function (id, svgContainer, idPostfix) {
    var existentElement = svgContainer.querySelector(getElementQuery(id, idPostfix));
    if (existentElement) {
        return existentElement;
    }
    return null;
};
export var getSvgSrc = function (element, sourceFormatter) {
    if (sourceFormatter === void 0) { sourceFormatter = function (source) { return source; }; }
    if (!element) {
        return null;
    }
    else {
        return 'data:image/svg+xml,' + encodeURIComponent(sourceFormatter(element.innerHTML));
    }
};
export var SnapshotFormat;
(function (SnapshotFormat) {
    SnapshotFormat["SVG"] = "image/svg";
    SnapshotFormat["PNG"] = "image/png";
    SnapshotFormat["JPG"] = "image/jpeg";
    SnapshotFormat["WEBP"] = "image/webp";
})(SnapshotFormat || (SnapshotFormat = {}));
export var snapshotDom = function (_a) {
    var container = _a.container, _b = _a.dimensions, dimensions = _b === void 0 ? {} : _b, _c = _a.format, format = _c === void 0 ? SnapshotFormat.PNG : _c, _d = _a.sourceFormatter, sourceFormatter = _d === void 0 ? function (source) { return source; } : _d, _e = _a.quality, quality = _e === void 0 ? 1 : _e, backgroundColor = _a.backgroundColor;
    return __awaiter(void 0, void 0, void 0, function () {
        var _f, input, output, svgFormatString, inputWidth, inputHeight, start, end, source, svgSrc, outputWidth, outputHeight, canvas, ctx, image, src;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    _f = dimensions !== null && dimensions !== void 0 ? dimensions : {}, input = _f.input, output = _f.output;
                    if (!input) {
                        input = container.getBoundingClientRect();
                    }
                    if (!output) {
                        output = input;
                    }
                    svgFormatString = 'data:image/svg+xml;charset=utf-8,';
                    inputWidth = input.width, inputHeight = input.height;
                    start = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"".concat(inputWidth, "\" height=\"").concat(inputHeight, "\">\n      <style scoped=\"\">\n        html::-webkit-scrollbar {\n          display: none;\n        }\n\n        html, body {\n          margin: 0;\n        }\n\n        svg {\n          overflow: visible;\n        }\n      </style>\n      <foreignObject x=\"0\" y=\"0\" width=\"").concat(inputWidth, "\" height=\"").concat(inputHeight, "\" style=\"float: left;\" externalResourcesRequired=\"true\">\n        <html xmlns=\"http://www.w3.org/1999/xhtml\">\n          <head/>\n          <body>\n  ");
                    end = "\n          </body>\n        </html>\n      </foreignObject>\n    </svg>\n  ";
                    source = start + sourceFormatter(container.innerHTML) + end;
                    svgSrc = svgFormatString + encodeURIComponent(source);
                    if (format === SnapshotFormat.SVG) {
                        return [2 /*return*/, svgSrc];
                    }
                    outputWidth = output.width, outputHeight = output.height;
                    canvas = document.createElement('canvas');
                    canvas.width = outputWidth;
                    canvas.height = outputHeight;
                    ctx = canvas.getContext('2d');
                    if (format === SnapshotFormat.JPG) {
                        ctx.fillStyle = backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : COLORS.DEFAULT_BACKGROUND;
                        ctx.fillRect(0, 0, canvas.width, canvas.height);
                    }
                    image = document.createElement('img');
                    return [4 /*yield*/, new Promise(function (resolve) {
                            image.onload = function () {
                                ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
                                resolve(null);
                            };
                            image.src = svgSrc;
                        })];
                case 1:
                    _g.sent();
                    src = '';
                    return [4 /*yield*/, new Promise(function (resolve) {
                            canvas.toBlob(function (blob) {
                                var reader = new FileReader();
                                reader.onloadend = function () {
                                    src = reader.result;
                                    resolve(null);
                                };
                                reader.readAsDataURL(blob);
                            }, format, quality);
                        })];
                case 2:
                    _g.sent();
                    return [2 /*return*/, src];
            }
        });
    });
};
export var unique = function (values) { return Array.from(new Set(values)); };
//# sourceMappingURL=utils.js.map